import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../../assest/logo.png';
import { FaBars, FaTimes, FaPhoneAlt } from "react-icons/fa";
import './header.scss';

const Header = () => {
	const navigate = useNavigate();
	const [open, setOpen] = useState(false);
	
	const handleScrollToContact = () => {
		const section = document.getElementById("contact-section");
		if (section) {
			section.scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
			setOpen(false); // Close mobile menu after clicking contact
		}
	};
	
	return (
		<div className="mainHeader">
			<div className="subHeader">
				
				{/* LEFT */}
				<div className="LeftSideHeader" onClick={() => navigate('/')}>
					<img src={logo} alt="logo" />
				</div>
				
				{/*Center First*/}
				<div className={`CenterSideHeader ${open ? 'open' : ''}`}>
					{/* ✅ ADD THIS CLOSE BUTTON INSIDE DRAWER */}
					
					<ul>
						<li>अतिथि देवो भव</li>
					</ul>
				</div>
				
				
				{/* CENTER */}
				<div className={`CenterSideHeader ${open ? 'open' : ''}`}>
					{/* ✅ ADD THIS CLOSE BUTTON INSIDE DRAWER */}
					<div className="mobile-header">
						<img src={logo} alt="logo" onClick={() => navigate('/')} />
						<FaTimes onClick={() => setOpen(false)} />
					</div>
					
					<ul>
						<li><Link to="/" end onClick={() => setOpen(false)}> Stays</Link></li>
						<li><Link to="/homestays" onClick={() => setOpen(false)}> Home Stays</Link></li>
						<li><Link to="/farmstays" onClick={() => setOpen(false)}> Farm Stays</Link></li>
						{/* Show Contact Us in mobile menu as well */}
						
						<li className="mobile-only-contact">
							<button onClick={handleScrollToContact}>
								Contact Us →
							</button>
						</li>
					</ul>
					
					<div className="mobile-footer">
						<p className="HeaderLocation">📍 Solapur, Maharashtra, India</p>
						
						<p className="Header-brand-description">
							📞 Nikit Alagi - <Link
							to="tel:+919049928292"
							className="agent-call"
						>
							 +91 9049928292
						</Link>
						</p>
					</div>
				</div>
				
				{/* RIGHT */}
				<div className="RightSideHeader">
					<a className="phoneBox" href="tel:9049928292">
						<FaPhoneAlt />
						<span>+91 9049928292</span>
					</a>
					
					<button onClick={handleScrollToContact}>
						Contact Us →
					</button>
				</div>
				
				{/* MOBILE MENU TOGGLE */}
				<div className="menu-toggle" onClick={() => setOpen(!open)}>
					{open ? '' : <FaBars />}
				</div>
			</div>
			
			{open && <div className="overlay" onClick={() => setOpen(false)} />}
		</div>
	);
};

export default Header;